import { createSlice } from '@reduxjs/toolkit'
import { getWoodDoors, saveWoodDoor, createWoodDoor, deleteWoodDoor } from './woodDoorActions'

const initialState = {
  woodDoors: [],
  loading: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedWoodDoor: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const woodDoorSlice = createSlice({
  name: 'woodDoors',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedWoodDoor = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getWoodDoors.fulfilled, (state, { payload }) => {
        state.loading = false
        state.woodDoors = payload
        /*payload.forEach((i) => {
          state.woodDoors[i.id] = i
        })*/
      })
      .addCase(getWoodDoors.pending, (state) => {
        state.loading = true
        state.loadingError = null
        state.savingError = null
      })
      .addCase(getWoodDoors.rejected, (state, { payload }) => {
        state.loading = false
        state.loadingError = payload
      })
      .addCase(saveWoodDoor.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveWoodDoor.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedWoodDoor = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveWoodDoor.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createWoodDoor.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createWoodDoor.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedWoodDoor = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createWoodDoor.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteWoodDoor.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteWoodDoor.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteWoodDoor.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
    /*.addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )*/
  },
})

export const { clear } = woodDoorSlice.actions
export default woodDoorSlice.reducer
